import { render, staticRenderFns } from "./PreloadAdyenBuyPremium.vue?vue&type=template&id=2a9a2360&scoped=true&"
import script from "./PreloadAdyenBuyPremium.vue?vue&type=script&lang=js&"
export * from "./PreloadAdyenBuyPremium.vue?vue&type=script&lang=js&"
import style0 from "./PreloadAdyenBuyPremium.vue?vue&type=style&index=0&id=2a9a2360&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9a2360",
  null
  
)

export default component.exports